import type { PipelineCardDetail as PipelineCardDetailDto } from '@/pages/pipelines/common/types';

import {
  getPipelineDetailBlockLabel,
  getPipelineDetailRowLabel,
  getPipelineDetailRowValue,
} from './presentation';
import {
  DetailBlock,
  DetailLabel,
  DetailRow,
  DetailRowLabel,
  DetailRowValue,
  DetailSection,
  DetailValue,
  DetailValueLink,
} from './styled';

type Props = {
  detail: PipelineCardDetailDto;
};

export const PipelineDetailSections = ({ detail }: Props) => (
  <>
    {detail.sections.map((section) => {
      if (section.rows.length === 1) {
        const row = section.rows[0];
        const value = getPipelineDetailRowValue(row);

        return (
          <DetailBlock key={section.key}>
            <DetailLabel>{getPipelineDetailBlockLabel(detail, section)}</DetailLabel>
            <DetailValue data-tone={row.tone}>{renderDetailValue(value, row.href)}</DetailValue>
          </DetailBlock>
        );
      }

      return (
        <DetailSection key={section.key}>
          {section.rows.map((row) => (
            <DetailRow key={row.key}>
              <DetailRowLabel>{getPipelineDetailRowLabel(detail, row)}</DetailRowLabel>
              <DetailRowValue data-tone={row.tone}>
                {renderDetailValue(getPipelineDetailRowValue(row), row.href)}
              </DetailRowValue>
            </DetailRow>
          ))}
        </DetailSection>
      );
    })}
  </>
);

const renderDetailValue = (value: string | null, href: string | null | undefined) => {
  const label = value ?? 'Unavailable';

  if (!href) return label;

  return (
    <DetailValueLink to={href} size="mini">
      {label}
    </DetailValueLink>
  );
};
